import * as React from 'react';
import { getTheme, mergeStyleSets } from '@fluentui/react/lib/Styling';

import { ScrollablePane, IScrollablePaneStyles } from '@fluentui/react/lib/ScrollablePane';
import { Sticky, StickyPositionType } from '@fluentui/react/lib/Sticky';

const lorem = (length: number) =>
    `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque euismod, urna eu tincidunt consectetur, nisi nisl aliquam enim, eget facilisis quam felis id mauris. 
    Suspendisse potenti. Proin ac neque nec sapien dictum dictum. Etiam euismod, justo at facilisis cursus, enim erat dictum urna, nec dictum erat elit at erat. 
    Mauris euismod, sapien eu aliquam cursus, enim erat dictum urna, nec dictum erat elit at erat. 
    Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. 
    Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; 
    Integer euismod, justo at facilisis cursus, enim erat dictum urna, nec dictum erat elit at erat. 
    `.repeat(Math.ceil(length / 400)).slice(0, length);

export interface IScrollablePaneExampleItem {
    color: string;
    text: string;
    index: number;
}
const theme = getTheme();
const classNames = mergeStyleSets({
    wrapper: {
        height: '40vh',
        position: 'relative',
        maxHeight: 'inherit',
    },
    pane: {
        maxWidth: 400,
        border: '1px solid ' + theme.palette.neutralLight,
    },
    sticky: {
        color: theme.palette.neutralDark,
        padding: '5px 20px 5px 10px',
        fontSize: '13px',
        borderTop: '1px solid ' + theme.palette.black,
        borderBottom: '1px solid ' + theme.palette.black,
    },
    textContent: {
        padding: '15px 10px',
    },
});
const scrollablePaneStyles: Partial<IScrollablePaneStyles> = { root: classNames.pane };
const colors = ['#eaeaea', '#dadada', '#d0d0d0', '#c8c8c8', '#a6a6a6', '#c7e0f4', '#71afe5', '#eff6fc', '#deecf9'];
const items = Array.from({ length: 5 }).map((item, index) => ({
    color: colors.splice(Math.floor(Math.random() * colors.length), 1)[0],
    text: lorem(600),
    index,
}));
const createContentArea = (item: IScrollablePaneExampleItem) => (
    <div
        key={item.index}
        style={{
            backgroundColor: item.color,
        }}
    >
        <Sticky stickyPosition={StickyPositionType.Footer} >
            <div role="heading" aria-level={1} className={classNames.sticky}>
                Sticky Component #{item.index + 1}
            </div>
        </Sticky>
        <div className={classNames.textContent}>{item.text}</div>
    </div>
);
const contentAreas = items.map(createContentArea);

export const ScrollablePaneDefaultExample: React.FunctionComponent = () => (
    <div style={{ width: '500px', height: '500px' }}>

        <div>
            <h1 style={{ position: 'sticky', top: 0, border: '1px solid gray', padding: '2px' }}>Plan 1</h1>
            <div>
                {lorem(2000)}
            </div>
            <h2 style={{ position: 'sticky', top: 20, border: '1px solid gray', padding: '2px' }}>Benefit 1</h2>
            <div style={{ border: '1px solid gray', padding: '2px' }}>
                {lorem(4000)}
            </div>
            <h2 style={{ position: 'sticky', top: 40, border: '1px solid gray', padding: '2px' }}>Benefit 2</h2>
            <div style={{ border: '1px solid gray', padding: '2px' }}>
                {lorem(6000)}
            </div>
        </div>

        <div>
            <h1 style={{ position: 'sticky', top: 0 }}>Plan 2</h1>
            <span>
                {lorem(2000)}
            </span>
            <span style={{ border: '1px solid gray', padding: '2px', display: 'block' }}>
                <h2 style={{ position: 'sticky', top: 20 }}>Benefit 1</h2>
                {lorem(2000)}
            </span>
            <span>
                <h2 style={{ position: 'sticky', top: 20 }}>Benefit 2</h2>
                {lorem(2000)}
            </span>
        </div>

        <div>
            <h1 style={{ position: 'sticky', top: 0 }}>Plan</h1>
            <span>
                {lorem(2000)}
            </span>
        </div>

        <div>
            <h1>Hello</h1>
            <span>
                {lorem(2000)}
            </span>
        </div>




    </div>
);

export default ScrollablePaneDefaultExample;